module.exports = __webpack_public_path__ + "img/olt_10kl.4805dd62.jpg";